import { MenuItem, MenuItemOptions } from "primereact/menuitem";
import { TabMenu } from "primereact/tabmenu";
import { TabMenuProps } from "primereact/tabmenu";
import { isValidElement, ReactNode } from "react";
import { NavLink, useLocation } from "react-router-dom";

export function PrimeTabMenu({
  model,
  className,
  modelClassName,
  modelLabelClassName,
  ...rest
}: TabMenuProps & {
  modelClassName?: string;
  modelLabelClassName?: string;
}) {
  const location = useLocation();
  const items =
    model?.map((menuItem) =>
      menuItemWithTemplate(menuItem, modelClassName, modelLabelClassName),
    ) || [];

  const activeIndex = items.findIndex((item) => item.url === location.pathname);

  return (
    <TabMenu
      activeIndex={activeIndex}
      className={className}
      model={items}
      {...rest}
    />
  );
}

function link(
  hasChildren: boolean,
  item: MenuItem,
  { className, labelClassName }: MenuItemOptions,
): ReactNode {
  return (
    <NavLink
      className={({ isActive }) =>
        `flex gap-2${isActive ? " !border-b-8 !border-gray-300" : ""}${className ? ` ${className}` : ""}`
      }
      to={item.url || "#"}
    >
      {icon(item.icon)}
      {item.label && <label className={labelClassName}>{item.label}</label>}
      {hasChildren && <i className="pi pi-chevron-down" />}
    </NavLink>
  );
}

function icon(icon?: unknown): ReactNode {
  if (isValidElement(icon)) {
    return icon;
  } else if (typeof icon === "string") {
    return <i className={icon} />;
  }
}

function menuItemWithTemplate(
  menuItem: MenuItem,
  modelClassName?: string,
  modelLabelClassName?: string,
): MenuItem {
  return {
    ...menuItem,
    template: (item, options, ...rest) =>
      link(
        !!menuItem.items,
        item,
        {
          ...options,
          className: `${modelClassName} ${options?.className}`,
          labelClassName: `${modelLabelClassName} ${options?.labelClassName}`,
        },
        ...rest,
      ),
    ...(menuItem.items && {
      items: menuItem.items.map((item: MenuItem) =>
        menuItemWithTemplate(item, modelClassName, modelLabelClassName),
      ),
    }),
  };
}
